import { render, staticRenderFns } from "./UiBadge.vue?vue&type=template&id=7dc02ddf&"
import script from "./UiBadge.vue?vue&type=script&lang=js&"
export * from "./UiBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports